
import Vue from 'vue';
import TeamMemberTeamRoleTableCell from './TeamMemberTeamRoleTableCell.vue';
import { TEAM_ROLE_DETAILS } from '@/constants/constants';
import { ROUTER } from '@/router/constants';
import { mapGetters, mapState } from 'vuex';
import ClipboardCopy from '@/components/ClipboardCopy.vue';
import TeamMemberJoinedStatus from '@/views/Team/TeamMemberJoinedStatus.vue';
import BaseStyledMenu from '@/components/base/BaseStyledMenu.vue';
import { TeamUserMixin } from '@/mixins/TeamUserMixin';

export default Vue.extend({
	name: 'TeamMemberRow',
	props: {
		teamMember: { type: Object, required: true },
		currTeam: { type: Object, required: true },
		currTeamUserRole: { type: Object, default: null },
		teamUserRoleDefs: { type: Array, default: () => [] },
		// Added on this page and shown ahead of the listing (utils/justAdded.ts)
		justAdded: { type: Boolean, default: false },
	},
	data () {
		return {
			TEAM_ROLE_DETAILS,

			MORE_ACTIONS_ITEM_VALUE: {
				ROLE: 'role',
				DELETE: 'delete',
			},
		};
	},
	mixins: [
		TeamUserMixin,
	],
	computed: {
		...mapState([
			'user',
			'team',
		]),
		...mapGetters([
			'displayLabels',
			'companyClubOfferBenefits',
		]),
		isAccepted () {
			return !!this.teamMember.acceptedAt;
		},
		isSelfMember () {
			return !!(this.user && this.user.id === this.teamMember.userId);
		},
		moreActionsMenuItems () {
			if (this.scimProvisioningLocksMembership) return [];
			let idIncrementer: number = 0;
			return [
				...((this.hasManageTeamsPermission || (this.checkManageTeamMembersPermission(this.currTeam, this.currTeamUserRole) && !this.isSelfMember)) && this.currTeam?.isActive ? [
					{
						id: idIncrementer++,
						icon: 'mdi-shield-account-outline',
						label: `Update Role`,
						description: `Change ${this.displayLabels.team} role`,
						value: this.MORE_ACTIONS_ITEM_VALUE.ROLE,
						isUpsell: !this.companyClubOfferBenefits.isEnterprise,
					},
				] : []),
				...((this.hasManageTeamsPermission || this.checkManageTeamMembersPermission(this.currTeam, this.currTeamUserRole)) && !this.isSelfMember ? [
					{
						id: idIncrementer++,
						icon: 'mdi-account-minus-outline',
						iconStyle: { color: 'var(--red-500)' },
						descriptionStyle: { color: 'var(--grey-400)' },
						label: `Remove From ${this.displayLabels.team}`,
						description: `They will lose access to this ${this.displayLabels.team}`,
						value: this.MORE_ACTIONS_ITEM_VALUE.DELETE,
					},
				] : []),
			];
		},
	},
	methods: {
		onSelectedMoreActions (moreActionsItemValue: string) {
			switch (moreActionsItemValue) {
				case this.MORE_ACTIONS_ITEM_VALUE.ROLE:
					this.$emit('edit-team-members', { teamMembers: [this.teamMember], team: this.currTeam });
					break;
				case this.MORE_ACTIONS_ITEM_VALUE.DELETE:
					this.$emit('remove-team-members', { teamMembers: [this.teamMember], team: this.currTeam });
					break;
				default:
					break;
			}
		},
		onViewTeamMember () {
			if (!this.isAccepted) return;
			this.routerPush(this.$route, this.$router, {
				name: ROUTER.TEAM_MEMBER_DASHBOARD,
				params: {
					teamId: this.currTeam.id,
					teamMemberId: this.teamMember.id,
				},
				query: this.$route.query,
			});
		},
	},
	components: {
		ClipboardCopy,
		TeamMemberJoinedStatus,
		BaseStyledMenu,
		TeamMemberTeamRoleTableCell,
	},
});
